import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { closeDialogOnEscape } from '@shared/helpers';

@Component({
    selector: 'app-unsaved-changes',
    templateUrl: './unsaved-changes.component.html',
    styleUrls: ['./unsaved-changes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnsavedChangesComponent implements OnInit {
  static readonly componentName = 'UnsavedChangesComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public sysText: any,
    private dialogRef: MatDialogRef<UnsavedChangesComponent>,
    ) { }

  ngOnInit() {
    closeDialogOnEscape(this.dialogRef, null, () => this.dialogRef.close(false));
  }
}
